import { Flex, Text } from "@chakra-ui/react";
import UserAvatar from "components/elements/UserAvatar";

type UserActive = {
  id: string;
  type: string;
  avatar: string | null;
  is_active: boolean;
  job_title: string;
  last_name: string;
  first_name: string;
  company: {
    name: string;
  };
};

export function ActivatedUser({ user }: { user: UserActive }) {
  return (
    <Flex alignItems="center">
      <UserAvatar size="40px" mr="8px" user={user} hideOnline />
      <Flex flexDir="column">
        <Text
          color="black"
          fontSize="14px"
          fontWeight="500"
          mb={1}
          style={{ whiteSpace: "nowrap" }}
        >
          {user.first_name} {user.last_name}
        </Text>
        <Text
          color="gray.200"
          fontSize="12px"
          lineHeight="12px"
          mt="0px"
          style={{ whiteSpace: "nowrap" }}
        >
          {user.type === "borrower" ? user.company.name : user.job_title}
        </Text>
      </Flex>
    </Flex>
  );
}
